<template>
  <v-dialog
    v-if="!!data"
    v-model="showDialog"
    :persistent="isUploading"
    width="500"
  >
    <v-card class="y-4">
      <v-card-title class="text-h5 grey lighten-2">
        Mes Travaux Singulis
      </v-card-title>

      <v-card-text>
        <br>
        <v-alert
          v-if="data.singulisWork && data.singulisWork.hasWork"
          type="warning"
          outlined
        >
          La copie de <b>{{ data.singulisWork.studentName }}</b> avec la note de {{ data.singulisWork.studentScore }} a déjà été déposée sur nos serveurs.
          <br>
          Pour toute modification, veuillez téléverser à nouveau une copie avec les informations nécessaires.
        </v-alert>
        <br>
        <p class="black--text py-2">
          Déposer la meilleure copie Singulis pour la classe <b>{{ data.name }}</b> au format PDF.
        </p>
        <v-text-field
          v-model="name"
          label="Nom et prénom de l'élève"
          outlined
          :error-messages="nameErrors"
          @blur="$v.name.$touch()"
        />
        <br>
        <p class="black--text">
          {{ singulisTravauxNoteLabel }}
        </p>
        <v-text-field
          v-model="note"
          label="Note"
          type="number"
          outlined
          :error-messages="noteErrors"
          @blur="$v.note.$touch()"
        />
        <br>
        <v-file-input
          v-model="file"
          accept="application/pdf"
          show-size
          label="Sélectionner une copie"
          :error-messages="fileErrors"
          @blur="$v.file.$touch()"
        />

        <v-alert
          v-if="hasError"
          type="error"
          outlined
        >
          Un problème est survenu lors du téléversement de la copie. Veuillez essayer plus tard ou contacter la webmagistra.
          <br>
          {{ hasError }}
        </v-alert>
      </v-card-text>
      <v-progress-linear
        v-if="isUploading"
        height="25"
        :value="progress"
      >
        <template v-slot:default="{ value }">
          <strong>{{ Math.ceil(value) }}%</strong>
        </template>
      </v-progress-linear>
      <v-divider />

      <v-card-actions>
        <v-btn
          text
          :disabled="isUploading"
          @click="showDialog = false"
        >
          Fermer
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="isUploading"
          :disabled="isUploading"
          @click="upload"
        >
          Téléverser
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { get, call } from 'vuex-pathify'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    mixins: [validationMixin],
    props: {
      value: Boolean,
      data: Object,
    },
    validations: {
      name: { required },
      note: { required },
      file: { required },
    },
    data: () => ({
      name: '',
      note: 0,
      file: null,
      progress: 0,
      isUploading: false,
      hasError: '',
    }),
    computed: {
      inscriptionId: get('artifex/inscription.id'),
      singulisTravauxNoteLabel: get('artifex/config.edition.singulisTravauxNoteLabel'),
      showDialog: {
        get () { return this.value },
        set (val) { this.$emit('input', val) },
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.required && errors.push('Ce champ est manquant.')
        return errors
      },
      noteErrors () {
        const errors = []
        if (!this.$v.note.$dirty) return errors
        !this.$v.note.required && errors.push('Ce champ est manquant.')
        return errors
      },
      fileErrors () {
        const errors = []
        if (!this.$v.file.$dirty) return errors
        !this.$v.file.required && errors.push('Choisissez une copie à téléverser.')
        return errors
      },
    },
    methods: {
      loadClasses: call('artifex/loadClasses'),
      upload () {
        this.hasError = ''
        this.progress = 0

        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        const form = new FormData()
        form.append('id', this.data.id)
        form.append('name', this.name)
        form.append('note', this.note)
        form.append('file', this.file)

        const config = {
          onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            this.progress = percentCompleted
          },
        }

        this.isUploading = true
        this.$http.api
          .put(`/participant/classes/${this.data.id}/work/singulis`, form, config)
          .then(() => {
            this.name = ''
            this.note = 0
            this.file = null
            this.showDialog = false
          })
          .catch(err => {
            this.hasError = err.response ? err.response.data : err
          })
          .finally(() => {
            this.isUploading = false
            this.loadClasses()
          })
      },
    },
  }
</script>
